import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-oppo-gulf-tournaments',
  templateUrl: './oppo-gulf-tournaments.component.html',
  styleUrls: ['./oppo-gulf-tournaments.component.scss']
})
export class OppoGulfTournamentsComponent implements OnInit {
  tournaments = [];

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
  }
  changeRoute(param) {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('reno-6-pubg-mobile-cup-gulf', 1, 'pubg').subscribe(res => {
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })
  }

}
